import { LitElement, html, css, nothing, PropertyValues } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { SvgIcons } from '../voyage-svg-icons/src/voyage-svg-icons';
import { FeedbackTypes } from '../../src/services/types/vessel-notifications-services.types';
import { VesselFeedbackStatusModel } from '../../src/models/vessel-feedback-status-model';
import "@maersk-global/mds-components-core/mc-modal";
import { VesselFeedbackStatusModelEvents } from '../../src/models/vessel-feedback-status-model-impl';

interface Feedback {
    id: FeedbackTypes;
    icon: SvgIcons;
    className: string;
    title: string;
    score: number;

}
const feedbackArray: Feedback[] = [
    {
        id:FeedbackTypes.VerySad,
        icon:SvgIcons.faceVerySad, 
        className:"very-sad",
        title: FeedbackTypes.VerySad, 
        score: 1
    },
    {
        id:FeedbackTypes.Sad,
        icon:SvgIcons.faceSad, 
        className:"sad",
        title: FeedbackTypes.Sad,
        score: 2
    },
    {
        id:FeedbackTypes.Neutral,
        icon:SvgIcons.neutral, 
        className:"neutral",
        title: FeedbackTypes.Neutral,
        score: 3
    },
    {
        id:FeedbackTypes.Happy,
        icon:SvgIcons.faceHappy, 
        className:"happy",
        title: FeedbackTypes.Happy,
        score: 4,
    },
    {
        id:FeedbackTypes.VeryHappy,
        icon:SvgIcons.faceVeryHappy, 
        className:"very-happy",
        title: FeedbackTypes.Happy,
        score: 5,
    }
]

@customElement('voy-feature-feedback-popup')
export class VoyVFeedbackPopup extends LitElement {
    @property({ type: Boolean, reflect: true }) shown: boolean = false;
    @property({ attribute: false}) private _selected: Feedback | null = null;
    @property({ attribute: false}) private _comment: string = "";
    @property({ attribute: false}) private _submitted: boolean = false;
    @property({ type: Boolean, reflect: true }) showCloseIcon: boolean = false;
   
    static get styles() {
        return [
            css`
            :host {
                font-family: MaerskText;
            }

            .comment {
                font-family: 'MaerskText';
                width: 412px;
                height: 50px;
                border: 1px solid #c4c4cd;
                line-height: 20px;
                resize: vertical;
                border-radius: 6px;
            }

            #alarm-popup .popup {
                width: 400px;
                max-width: 80vw;
                height: 40vh;
                padding:0 24px;
            } 

            .content {
                margin-left: 20px;
            }

            .max-width-container h2 {
                margin-top: 0px;
            }

            .name {
                color: var(--neutrals-grey-02, grey);
                font-size: 16px;
                font-family: MaerskText;
                line-height:20px;
                font-weight: 400;
                margin-top: 20px;
                margin-bottom: 10px;
            }

            .desc {
                color: var(--neutrals-grey-02, grey);
                font-size: 14px;
                font-family: MaerskText;
                line-height:20px;
                margin-top: -10px;
            }

            .desc span {
                text-decoration: underline;
                cursor: pointer;
            }

            #alarm-popup #footer {
                display: flex;
                justify-content: flex-end;
                padding: 12px;
                background: #F7F7F7;
            }
            
            .title {
                margin-top: 0px;
                font-family: MaerskText;
            }
            
            #alarm-popup #footer button {
                height: 35px;
                min-width: 80px;
                font-size: 14px;
                font-family: MaerskText;
                background: none;
                border: none;
                outline: none;
                cursor: pointer;
                border-radius: 3px;
                width: auto;
            }

            #alarm-popup #footer .submit-button {
                margin-right: 20px;
                border-radius: 6px;
            }

            .comment-input{
                width: 100%;
                position: realtive;
            }

            .max-width-container {
                width: 100%;
            }

            .center {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
            }
            
            .comment-input > textarea {
                white-space: normal;
                padding-left: 10px;
                font-family: MaerskText;
            }

            .footer {
                text-align: end;
                padding: 16px 24px;
                margin: -24px;
                margin-top: 20px;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                padding: 16px 24px;
                gap: 12px;
                height: 64px;
                background: #F7F7F7;
                border-bottom-left-radius: 6px;
                border-bottom-right-radius: 6px;
            }

            .footer-button {
                background-color: #FFFFFF;
            }

            .feedback-icon {
                text-align: center;           
            }

            .feedback-icon span {
                cursor: pointer           
            }

            .very-sad[selected] {
                fill: red;
            }

            .sad[selected] {
                fill: #ee7f09;
            }

            .neutral[selected] {
                fill: #e4dc18;
            }

            .happy[selected] {
                fill: #78e3be;
            }

            .very-happy[selected]{
                fill:#079c69;
            }

            .error-message {
                color: red;
            }

            .rating {
                text-align: center;
            }

        `];
    }

    constructor() {
        super();

        this._onVesselFeedbackFetched = this._onVesselFeedbackFetched.bind(this);
    }

    render(){
       return html`${this._renderFeedbacktModal()}`
    }

    connectedCallback(): void {
        super.connectedCallback();
        VesselFeedbackStatusModel!.addEventListener(VesselFeedbackStatusModelEvents.VesselFeedbackFetched, this._onVesselFeedbackFetched);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        VesselFeedbackStatusModel!.removeEventListener(VesselFeedbackStatusModelEvents.VesselFeedbackFetched, this._onVesselFeedbackFetched);
    }

    updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);
    }

    private _onVesselFeedbackFetched(e: Event){
        this.shown = (<CustomEvent>e).detail;
    }

    private _renderFeedbacktModal() {
        if(!this.shown) return "";

        return html`<mc-modal
                heading= "What is your overall satisfaction with our service"
                ?open=${this.shown}
                dimension="small"
                width="505px"
                height="346px"

                hiddenfooter
                backdropcloseactiondisabled	
                escapecloseactiondisabled	
                entercloseactiondisabled
                ?hiddenclose=${!this.showCloseIcon}
                @closing=${() => {
                    this.dispatchEvent(new Event("close"));
                    this.shown = false;
                    this.showCloseIcon = false;
                    this._submitted = false;
                    this._selected = null;
                }}
                >
					${this._renderModalContent()}
					<div class = "footer">
                        <mc-button focusstartanchor  appearance="secondary" variant="filled" @click="${this._onSubmit}">Submit</mc-button>
					</div>
            </mc-modal>
        `
    }
   
    private _renderModalContent() {
        return html`
            <div class="feedback-icon">
                ${feedbackArray.map((feedback) =>{
                    return html`
                        <span class=${feedback.className} ?selected=${this._selected?.id === feedback.id} @click=${()=>{this._selected=feedback}}>
                            ${feedback.icon}
                        </span>  
                    `
                })}
                ${!this._selected && this._submitted ? html` <span class="error-message">*</span> `: nothing}                
            </div>
            ${this._selected ? html`<div class="rating">${this._selected?.title}</div>` : nothing}
            <div class="comment-input">
                <div class="name">Tell us more</div>
                <textarea class="comment" placeholder="Anything else to add" @input=${(e:Event) => this._onInput(e)}></textarea> 
            </div>
        `
    }

    private _onInput(e:Event) {
       this._comment = (<HTMLInputElement>e.target).value.trim();
    }

    private _onSubmit() {
        this._submitted = true;
        if(this._selected) {
            VesselFeedbackStatusModel!.setVesselFeedback(this._payloadForSubmitReason());
            this._submitted = false;
            this._selected = null;
            this._comment = ""
            this.shown = false;
            this.showCloseIcon = false;
            this.dispatchEvent(new Event('close'));
        }
    }

    private _payloadForSubmitReason() {        
        return {
            rating: this._selected?.score,  
            comments: this._comment
        }
    }; 
}
    